import {
  permitJiebeiConduct,
  getUserJiebeiInfo,
  borrowFromJiebei,
  repaymentJiebei,
  queryBorrowList,
  queryRepaymentList,
  queryPaymentList
} from "@/api/conduct";

import { SET_USER_LEND_INFO } from "@/store/mutation_types";
const conduct = {
  state: {
    lendInfo: {}
  },
  getters: {
    userLendInfo: state => state.lendInfo
  },
  mutations: {
    [SET_USER_LEND_INFO]: (state, playload) => {
      state.lendInfo = playload;
    }
  },
  actions: {
    async permitJiebeiConduct({ commit }, playload) {
      return await permitJiebeiConduct(playload.data, playload.config);
    },
    async getUserJiebeiInfo({ commit }, playload) {
      const resp = await getUserJiebeiInfo(playload.data, playload.config);
      const { code, data } = resp.data;
      if (code == 0) {
        commit(SET_USER_LEND_INFO, data);
      }
      return resp;
    },
    async borrowFromJiebei({ commit }, playload) {
      return await borrowFromJiebei(playload.data, playload.config);
    },
    async repaymentJiebei({ commit }, playload) {
      return await repaymentJiebei(playload.data, playload.config);
    },
    async queryBorrowList({ commit }, playload) {
      return await queryBorrowList(playload.data, playload.config);
    },
    async queryRepaymentList({ commit }, playload) {
      return await queryRepaymentList(playload.data, playload.config);
    },
    async queryPaymentList({ commit }, playload) {
      return await queryPaymentList(playload.data, playload.config);
    }
  }
};

export default conduct;
